import api from '@/api/fetchClient'

export default {
  getSalaryPayments (month, year) {
    return api.get(`salary/payments?month=${month}&year=${year}`, { authorized: true })
  },

  recordExpense (payload) {
    return api.post('salary/record-expense', payload, { authorized: true })
  },

  addPayment (payload) {
    return api.post('salary/pay', payload, { authorized: true })
  }
}
